var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { set } from "lodash";
import { array, date, object, string, number } from "yup";
import { DateFormatType } from "./generator-enum";
import { getPrograms } from "./generator-utils";
var programValidationScheme = function () {
    return object().shape({
        program: string().required("Musíte zvolit program"),
    });
};
var formatValidationScheme = function () {
    return object().shape({
        format: string().required("Vyberte požadovaný formát"),
    });
};
var infoValidationScheme = function (values) {
    var _a, _b, _c, _d, _e, _f;
    var program = values.program, format = values.format;
    var selectedProgram = getPrograms().find(function (_a) {
        var value = _a.value;
        return value === program;
    });
    var selectedFormatGroup = selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.formatGroups.find(function (_a) {
        var formats = _a.formats;
        return formats.find(function (_a) {
            var formatTypes = _a.formatTypes;
            return formatTypes.find(function (_a) {
                var value = _a.value;
                return value === format;
            });
        });
    });
    var selectedFormat = selectedFormatGroup === null || selectedFormatGroup === void 0 ? void 0 : selectedFormatGroup.formats.find(function (_a) {
        var formatTypes = _a.formatTypes;
        return formatTypes.find(function (_a) {
            var value = _a.value;
            return value === format;
        });
    });
    var selectedFormatType = selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.formatTypes.find(function (_a) {
        var value = _a.value;
        return value === format;
    });
    return object().shape(__assign(__assign(__assign({ projects: array()
            .min(1, "Povinný je minimálně jeden projekt")
            .max((_a = selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.maxProjectCount) !== null && _a !== void 0 ? _a : 1, "Maxim\u00E1ln\u00ED po\u010Det projekt\u016F je " + ((_b = selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.maxProjectCount) !== null && _b !== void 0 ? _b : 1))
            .of(object().shape(__assign(__assign(__assign({ name: string()
                .max((_c = selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.nameLimit) !== null && _c !== void 0 ? _c : 70, "Maxim\u00E1ln\u00ED d\u00E9lka n\u00E1zvu projektu je " + ((_d = selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.nameLimit) !== null && _d !== void 0 ? _d : 70) + " znak\u016F")
                .required("Název projektu je povinný") }, ((selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.goalLimit) && {
            goal: string()
                .max((_e = selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.goalLimit) !== null && _e !== void 0 ? _e : 420, "Maxim\u00E1ln\u00ED d\u00E9lka c\u00EDle projektu je " + ((_f = selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.goalLimit) !== null && _f !== void 0 ? _f : 420) + " znak\u016F")
                .required("Cíl projektu je povinný"),
        })), ((selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.dateFormat) === DateFormatType.Date && {
            date: object().shape({
                from: date()
                    .nullable()
                    .required("Termín zahájení fyzické realizace projektu je povinný"),
                to: date()
                    .nullable()
                    .required("Termín ukončení fyzické realizace projektu je povinný"),
            }),
        })), ((selectedFormat === null || selectedFormat === void 0 ? void 0 : selectedFormat.dateFormat) === DateFormatType.Year && {
            year: date()
                .nullable()
                .required("Termín ukončení fyzické realizace projektu je povinný"),
        })))) }, ((selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.programSupport) && {
        programSupport: string()
            .nullable()
            .required("Zvolte program podpory")
    })), ((selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.fullSponsored) && {
        sponsorSelect: string()
            .nullable()
            .required()
            .oneOf(["yes", "no"], "Vyberte financování projektu"),
    })), ((selectedFormatType === null || selectedFormatType === void 0 ? void 0 : selectedFormatType.debetFields) && {
        debetAll: number()
            .typeError("Zadejte číselní hodnotu")
            .min(0.01, "Částka musí být větší než 0")
            .required("Zadejte částku"),
        contributionFund: number()
            .typeError("Zadejte číselní hodnotu")
            .min(0.01, "Částka musí být větší než 0")
            .required("Zadejte částku"),
        contributionSubject: number()
            .typeError("Zadejte číselní hodnotu")
            .min(0.01, "Částka musí být větší než 0")
            .required("Zadejte částku"),
    })));
};
var printValidationScheme = function () {
    return object().shape({
        cropMarks: string()
            .required()
            .oneOf(["yes", "no"], "Vyberte zda chcete použít ořezové značky"),
    });
};
export var validateGeneratorForm = function (step, values) {
    var errors = {};
    try {
        var schema = null;
        switch (step) {
            case 0:
                schema = programValidationScheme();
                break;
            case 1:
                schema = formatValidationScheme();
                break;
            case 2:
                schema = infoValidationScheme(values);
                break;
            case 3:
                schema = printValidationScheme();
                break;
        }
        if (schema) {
            schema.validateSync(values, {
                abortEarly: false,
            });
        }
    }
    catch (error) {
        error.inner.forEach(function (err) {
            set(errors, err.path, err.message);
        });
    }
    return errors;
};
